import { actionCreator } from '@ardoq/rxbeach';

export const toggleFilterConditionsExpanded = actionCreator(
  '[filterConditionsSection] TOGGLE_FILTER_CONDITIONS_EXPANDED'
);
